import type { FavouriteStationsAdapter } from '@/lib/favouriteStations'

export const favouriteStationsAdapterLocalStorage: FavouriteStationsAdapter = {
  supportsSync: false,
  load: () => {
    return Promise.resolve([
      ...JSON.parse(localStorage.getItem('viritinFavouriteStations') || '[]'),
    ])
  },
  save: (ids) => {
    localStorage.setItem('viritinFavouriteStations', JSON.stringify(ids))
    return Promise.resolve(ids)
  },
  add: (_id) => Promise.resolve(true),
  remove: (_id) => Promise.resolve(true),
}
